/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createExp } from '../../factoriesAny.js';
export var expDependencies = {
  typedDependencies,
  createExp
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesExp.generated.js
// module id = isFd
// module chunks = 3